import { render, staticRenderFns } from "./CenterFormDialog.vue?vue&type=template&id=087443d1&scoped=true"
import script from "./CenterFormDialog.vue?vue&type=script&lang=js"
export * from "./CenterFormDialog.vue?vue&type=script&lang=js"
import style0 from "./CenterFormDialog.vue?vue&type=style&index=0&id=087443d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087443d1",
  null
  
)

export default component.exports